import { useGetLoginInfo } from "@multiversx/sdk-dapp/hooks/account"
import React from "react"
import { Route, Redirect } from "react-router-dom"
import { UNLOCK_ROUTE } from "routes";

const PrivateRoute = ({ component: Component, ...rest }) => {
    const { isLoggedIn } = useGetLoginInfo();
    return (
        <Route
            {...rest}
            render={(props) => (isLoggedIn ? <Component {...props} /> : <Redirect to={UNLOCK_ROUTE.path} />)}
        />
    )
}

export default PrivateRoute;